import React, { useState, useMemo, useEffect } from 'react';
import { fetchData } from '../../common/networkRequests';
import { getResultFromCondition } from "../../oro-module/commonFunctions";
import "./ProgressBar.css";


const ProgressBarCustom = (props) => {
  let { selectedTourBranch } = props.parentState.LocalVars;
  let { reportName, label_field, pct_labels, is_pct, subtotal_definitions } = props.component;
  let [percentage, setpercentage] = useState(0);

  const fillerStyles = {
    height: '100%',
    width: `${percentage}%`,
    backgroundColor: "#36424A",
    borderRadius: 'inherit',
    textAlign: 'right'
  }

  const labelStyles = {
    padding: 5,
    color: 'white',
    fontWeight: 'bold'
  }


  const setProgressData = (data) => {
    let val = getResultFromCondition(label_field, data.results[0]);
    let prog = getResultFromCondition(pct_labels, data.results[0]);

    let t = prog.split(",");
    let width = parseFloat(100 * (parseFloat(t[0]) / parseFloat(t[1]))).toFixed(2);
    if (isNaN(width)) { width = 0; }
    if (is_pct) {
      val = width;
    }
    val = Math.min(100, val);
    // console.log({ val, pct_labels, prog, data })
    setpercentage(val);
  }

  const getChartData = () => {
    let pd = { gui: "dashboard" };
    if (selectedTourBranch) {
      pd['branch_uid'] = selectedTourBranch.value;
      if (selectedTourBranch.more_1) {
        pd['more_1'] = selectedTourBranch.more_1;
      }
    }

    let saveThis = { dataType: "search", pageData: pd, currentPage: reportName };
    // console.log({ saveThis })
    fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setProgressData });
  }

  useEffect(() => getChartData(), [selectedTourBranch]);


  return (
    <div className="progressbar-container">
      <div style={fillerStyles}>
        <div style={labelStyles}>{`${percentage}%`}</div>
      </div>
    </div>
  );
};


export default ProgressBarCustom;